import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardActions,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import {
  ProductPod,
  ProductImage,
} from '@thd-olt-component-react/product-pod';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const ATCConfirmation = ({ itemId }) => {

  const { store } = useContext(ExperienceContext);

  return (
    <div data-testid="assistant-atc-confirmation" className="sui-my-3">
      <Card
        variant="border"
        orientation="vertical"
        disablePadding
      >
        <div className="sui-border-solid sui-border-b-1 sui-rounded-base sui-border-primary sui-p-4">
          <CardTitle
            leadingIcon={<ConfirmedFilled color="success" />}
            header="Added to Cart"
            headerWeight="bold"
            headerVariant="h3"
            actionPosition="start"
            grow
          />
        </div>
        <ProductPod
          itemId={itemId}
          storeId={store.storeId}
          hoverDelay={500}
          render={(pod) => (
            <div className="sui-flex sui-flex-wrap">
              <div className="sui-basis-1/4 sui-shrink">
                <ProductImage
                  itemId={pod.itemId}
                  showSecondaryImage={pod.showSecondaryImage}
                />
              </div>
              <div className="sui-basis-3/4 sui-flex sui-gap-2 sui-flex-col sui-flex-wrap sui-pl-4 sui-pb-4">
                <div className="sui-mb-5">
                  <ProductHeader
                    brand="above"
                    itemId={pod.itemId}
                    brandTitleMaxLine={4}
                    disableShopThisCollection
                  />
                </div>
                <div className="sui-flex sui-flex-col sui-flex-wrap sui-gap-2">
                  <Typography variant="body-small">Qty: 1</Typography>
                  <div>
                    <Price
                      itemId={itemId}
                      storeId={store.storeId}
                      basic
                      type="simple"
                      hideBadge
                      hideBulkPrice
                      hideLimitPerOrder
                      hidePromotions
                      hideSavingsText
                      hideRebates
                      omitDetails
                    />
                  </div>
                </div>
              </div>
              <div className="sui-basis-4/4 sui-grow">
                <CardActions>
                  <Button variant="primary" fullWidth href="https://www.homedepot.com/cart">View Cart</Button>
                </CardActions>
              </div>
            </div>
          )}
        />
      </Card>
    </div>
  );
};

ATCConfirmation.propTypes = {
  itemId: PropTypes.string.isRequired
};

ATCConfirmation.dataModel = extend(
  ProductPod,
  ProductImage,
  Price,
  ProductHeader,
);

export default ATCConfirmation;